import { CartRequest } from "../dto/request/cart-request.interface";
import { CartResponse } from "../dto/response/cart-response.interface";
import { Cart } from "../model/cart-model";

export class CartMapper {
  static fromCartResponseToCartModel(cartResponse: CartResponse): Cart {
    if (
      !cartResponse ||
      !cartResponse.cartProducts ||
      cartResponse.cartProducts.length === 0
    ) {
      return {
        id: cartResponse?.id ?? "",
        products: []};
    }
    return {
      id: cartResponse.id,
      products: cartResponse.cartProducts.map((product) => {
        // Busca a imagem correspondente à cor selecionada
        const selectedMockup = product.productStreamer.mockups.find(
          (mockup) => mockup.color === product.color
        );
        
        return {
          productId: product.productStreamerId,
          imageUrl: selectedMockup ? selectedMockup.url : product.productStreamer.mockups[0]?.url,
          name: product.productStreamer.name,
          color: product.color,
          size: product.size,
          price: product.productStreamer.price,
          discountPrice: 0,
          quantity: product.quantity,
          total_price: product.productStreamer.price * product.quantity};
      })};
  }

  static fromCartModelToCartRequest(cartModel: Cart): CartRequest {
    return {
      cartProducts: cartModel.products.map((product) => {
        return {
          quantity: product.quantity,
          color: product.color,
          size: product.size,
          productStreamerId: product.productId};
      })};
  }
}
